import React from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import SanitizedLink from '../../common/sanitizedLink';
import { MomentDate } from '../../common/momentComponent';
import MoneyComponent from '../../common/moneyComponent';

const rowType = {
    string: "string",
    date: "date",
    money: "money",
    link: "link"
}

class QuickReportRowCls extends React.Component {
    render() {
        if (isNullOrUndefined(this.props.value) || isNullOrUndefined(this.props.translationKey))
            return null;

        const type = isNullOrUndefined(this.props.type) || !Object.keys(rowType).includes(this.props.type)
            ? rowType.string : this.props.type

        return (
            <tr className={this.props.className}>
                <td><Translate id={this.props.translationKey} /></td>
                <td>
                    {type === rowType.string && this.props.value}
                    {type === rowType.date && <MomentDate value={this.props.value} />}
                    {type === rowType.money && <MoneyComponent value={Math.round(this.props.value)} currency={this.props.currency} />}
                    {type === rowType.link && this.renderLink(this.props.value, this.props.label)}
                </td>
            </tr>
        )
    }

    renderLink = (value, label) => <SanitizedLink link={value.indexOf("http") >= 0 ? value : `http://${value}`} label={label} />;
}

const QuickReportRow = withLocalize(QuickReportRowCls);

export default QuickReportRow;
export { QuickReportRow, rowType };

